type StyleReader = (element: Element) => Pick<CSSStyleDeclaration, 'overflowY' | 'paddingBottom'>;

const findRoomTarget = (element: HTMLElement, readStyle: StyleReader): HTMLElement => {
  for (let node = element.parentElement; node; node = node.parentElement) {
    if (/(auto|scroll)/.test(readStyle(node).overflowY)) {
      return node;
    }
  }

  return element.ownerDocument.body;
};

export default function addSuggestionRoom(
  element: HTMLElement,
  roomPx: number,
  readStyle: StyleReader = getComputedStyle,
): () => void {
  const target = findRoomTarget(element, readStyle);
  const previousPadding = target.style.paddingBottom;

  target.style.paddingBottom = `${parseFloat(readStyle(target).paddingBottom) + roomPx}px`;

  return () => {
    target.style.paddingBottom = previousPadding;
  };
}
